import { FC } from 'react'
import FieldWrapper from '../FieldWrapper/FieldWrapper'
import cn from './index.module.css'
import { Slider, SliderSingleProps } from 'antd'
import classNames from 'classnames'

interface ISliderField extends SliderSingleProps {
  label?: string
  value: number
  extraContent?: string
  tooltipOpen?: boolean
  onChange: (value: number) => void
  isInvalid?: boolean
  className?: string
  minTitle?: string
  maxTitle?: string
  description?: string
}

const SliderField: FC<ISliderField> = ({
  label,
  value,
  extraContent,
  tooltipOpen,
  onChange,
  isInvalid,
  className,
  maxTitle,
  minTitle,
  description,
  ...props
}) => {
  return (
    <FieldWrapper
      label={label}
      isInvalid={isInvalid}
      description={description}
      extraContent={
        extraContent ? (
          <div className={cn.valueContent}>{extraContent}</div>
        ) : null
      }
    >
      <Slider
        className={classNames(cn.slider, className)}
        value={value}
        onChange={onChange}
        tooltip={{ open: tooltipOpen, prefixCls: cn.tooltip }}
        {...props}
      />
      {(maxTitle || minTitle) && (
        <div className={cn.additional}>
          <div className={cn.title} style={{ marginRight: 'auto' }}>
            {minTitle}
          </div>
          <div className={cn.title} style={{ marginLeft: 'auto' }}>
            {maxTitle}
          </div>
        </div>
      )}
    </FieldWrapper>
  )
}

export default SliderField
